import gql from "graphql-tag";
import { MY_COMPANY_FRAGMENT } from "./fragment";

export const MY_COMPANY = gql`
  query MyCompanyInfo {
    myCompanyInfo {
      ...MyCompany
    }
  }
  ${MY_COMPANY_FRAGMENT}
`;
